import Sentry from "@/utility/errorTracking";
import globalStore from "@/store/store";
import { getUserInvestments } from "@/services/rest/user-investments";
import {
  setLoadingActionInv,
  setInvestmentsDataAction,
  setEmptyInvestmentsDataAction,
  setErrorActionInv,
} from "@/store/investments/investments";

export const skipPortfolioLoading = () => {
  globalStore.dispatch(setEmptyInvestmentsDataAction());
}

export const loadData = () => {
  //Calling dashboard API and storing data in redux store
  globalStore.dispatch(setLoadingActionInv(true));

  return new Promise((resolve,reject)=>{
    getUserInvestments()
    .then((response) => {
      let products = ["mutualFunds","stocks","fno"]

      products.forEach(product => {
        if(!response[product]){
          Sentry.captureException(new Error(`Missing portfolio data for ${product}`));
        } else if(response[product].hasError){
          Sentry.captureException(new Error(`Error in portfolio data for ${product} - ${response[product].message}`));
        }
      })

      globalStore.dispatch(setInvestmentsDataAction(response));
      resolve(response)
    })
    .catch((error) => {
      globalStore.dispatch(setErrorActionInv(error.message));
      globalStore.dispatch(setInvestmentsDataAction({
        "mutualFunds": {
          hasError: true
        },
        "stocks": {
          hasError: true
        },
        "fno": {
          hasError: true
        },
        "total": {
          "investment": 0,
          "current": 0,
          "unrealizedGainLoss": 0,
          "unrealizedGainLossPercent": 0,
          "realizedGainLoss": 0
        }
      }));
      reject(error)
    })
    .finally(() => {
      globalStore.dispatch(setLoadingActionInv(false));
    });
  })
};
